export default function SvgFile() {
  return (
    <>
      <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 48 48"
      width="20px"
      cursor="pointer"
      >
        <g data-name="Layer 2">
          <path fill="none" d="M0 0H48V48H0z"></path>
          <g data-name="icons Q2">
            <path d="M13.9 44a10 10 0 01-7-2.9 9.8 9.8 0 010-14l7.2-7.2a9.8 9.8 0 0114 0 2 2 0 01-2.8 2.8 6 6 0 00-8.4 0l-7.2 7.2a5.9 5.9 0 008.4 8.4l4.5-4.7a2 2 0 012.8 2.8l-4.5 4.7a10 10 0 01-7 2.9z"></path>
            <path d="M26.9 31a10 10 0 01-7-2.9 2 2 0 012.8-2.8 6 6 0 008.4 0l7.2-7.2a5.9 5.9 0 00-8.4-8.4l-4.5 4.7a2 2 0 01-2.8-2.8l4.5-4.7a9.9 9.9 0 0114 14l-7.2 7.2a10 10 0 01-7 2.9z"></path>
          </g>
        </g>
      </svg>
    </>
  );
}
